export const PROFILE_TOAST_SCOPE = 'profile-page';
